import { PortfolioRepo } from "../../../portfolio/portfolio.repo";
import { isNullOrUndefined } from "util";
import * as moment from "moment";

class CreateCashTransactionDialogController {
  public cashTransaction: any = {};
  public isDebitAmount: boolean = false;

  public transactionTypes: any = [];
  public selectedTransactionType: string;
  public searchTerm: string = "";

  public transactionForm: ng.IFormController;

  public portfolio: any;

  public cashAccounts: any;
  public selectedCashAccount: any;
  public isReconciled: boolean;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private portfolioRepo: PortfolioRepo,
    private notifyjs
  ) {}

  $onInit() {
    this.cashTransaction.transactionDate = new Date();

    this.portfolioRepo
      .getPortfolioCashAccounts(this.portfolio.portfolioId, this.isReconciled)
      .then((res) => {
        this.cashAccounts = res.data;
      });
  }

  formatDate(selectedDate) {
    return moment(selectedDate).format("YYYY-MM-DD");
  }

  save() {
    this.cashTransaction.transactionType = this.selectedTransactionType;
    this.cashTransaction.isDebitAmount = this.isDebitAmount;
    if (this.transactionForm.$valid) {
      this.portfolioRepo
        .addCashTransaction(this.selectedCashAccount.id, this.cashTransaction, this.isReconciled)
        .then((res) => {
          this.$mdDialog.hide(true);
        })
        .catch((err) => {
          this.notifyjs(`Failed to add cash transaction : ${err.data}`);
        });
    }
  }

  cancel() {
    this.$mdDialog.hide();
  }

  clearSearchTerm() {
    this.searchTerm = "";
  }

  getSelectedText() {
    if (this.selectedTransactionType !== undefined) {
      return this.selectedTransactionType;
    } else {
      return "Select a Transaction Type";
    }
  }

  clearOutAmount() {
    this.cashTransaction.amountDebited = 0;
    this.cashTransaction.amountCredited = 0;
  }

  roundAmounts() {
    if (this.isDebitAmount) {
      if (!isNullOrUndefined(this.cashTransaction.amountDebited)) {
        this.transactionForm.amount.$viewValue =
          +this.transactionForm.amount.$viewValue;
        this.transactionForm.amount.$viewValue =
          this.transactionForm.amount.$viewValue.toFixed(2);
        this.cashTransaction.amountDebited =
          +this.cashTransaction.amountDebited.toFixed(2);
      }
    } else {
      if (!isNullOrUndefined(this.cashTransaction.amountCredited)) {
        this.transactionForm.amount.$viewValue =
          +this.transactionForm.amount.$viewValue;
        this.transactionForm.amount.$viewValue =
          this.transactionForm.amount.$viewValue.toFixed(2);
        this.cashTransaction.amountCredited =
          +this.cashTransaction.amountCredited.toFixed(2);
      }
    }
  }

  getCashTransactions = () => {
    if (!isNullOrUndefined(this.selectedCashAccount)) {
      this.portfolioRepo
        .getCashTransactionTypes(this.selectedCashAccount.id)
        .then((res) => {
          this.transactionTypes = res.data;
        })
        .catch((err) => {
          this.notifyjs(`Failed to load transaction types : ${err.data}`);
        });
    } else {
      this.notifyjs("Please select a cash account", "warning");
    }
  };
}

export const createCashTransactionDialog: angular.IComponentOptions = {
  template: require("./createCashTransaction.dialog.html"),
  controller: CreateCashTransactionDialogController,
  bindings: {
    portfolio: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/performanceManagement/createCashTransactionDialog/createCashTransaction.dialog.ts